/**
 * @module
 */
export * from '../utils.ts';

// TODO
// @deprecated use `@noble/curves/utils.js`
